import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import {
  getApaAssetWithAppKey,
  getApaTranslationsWithAppKey,
} from '../services/api/apa/metadata';
import {
  setPlanSelectorAsset,
  setPlanSelectorTranslations,
} from '../actions/response';
import { setPlanSelectorOffers } from '../actions/response';
import { getPlanOffers } from '../services/api/plan/planOffers';
import { pushPaymentEvent } from 'containers/Payment/utils/metrics';
import Utils from 'utils/Utils';
import { getRegion } from 'utils/Region';
import { pushGTMEvent } from 'containers/Player/utils/analytics';
import { decodeString } from 'utils/decodeString';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { getWorkflowStart } from 'action-creators/payway/workflowStart';
import { setCurrentPBI } from 'action-creators/payway/currentPayment/currentPBI';
import { pushBeginCheckoutEvent } from 'containers/Payment/PlanSelect/utils';
import { hideHeadband } from 'action-creators/headband';
import { getPurchaseButtonInfo } from 'action-creators/payway/purchaseButtonInfo';

export const useGetPlanSelectorInfo = () => {
  const [loadingTranslations, setLoadingTranslations] = useState(null);
  const [loadingAssets, setLoadingAssets] = useState(null);
  const [loadingPlans, setLoadingPlans] = useState(true);

  const dispatch = useDispatch();

  const planSelectorTranslations = useSelector(
    state => state?.planSelectorInfo?.translations,
  );
  const planSelectorAssets = useSelector(
    state => state?.planSelectorInfo?.asset,
  );
  const user = useSelector(state => state.user);
  const { nodesSelected } = useMenuRedirect();

  const getPlanSelectorKeys = async offers => {
    setLoadingTranslations(true);
    const translations = await offers?.reduce(async (acc, productType) => {
      const accAll = await acc;
      accAll[productType] = await getApaTranslationsWithAppKey(productType);
      return accAll;
    }, Promise.resolve({}));
    setLoadingTranslations(false);
    dispatch(setPlanSelectorTranslations(translations));
  };

  const getPlanSelectorAssetKeys = async offers => {
    setLoadingAssets(true);
    const asset = await offers?.reduce(async (acc, productType) => {
      const accAll = await acc;
      accAll[productType] = await getApaAssetWithAppKey(productType);
      return accAll;
    }, Promise.resolve({}));
    dispatch(setPlanSelectorAsset(asset));
    setLoadingAssets(false);
  };

  const getPlanSelectorTranslationKeyData = (productType, key) =>
    planSelectorTranslations?.[productType]?.[key] || '';
  const getPlanSelectorAssetKeyData = (productType, key) =>
    planSelectorAssets?.[productType]?.[key] || '';

  const getPlanSelectorOffers = async () => {
    setLoadingPlans(true);
    await dispatch(getPurchaseButtonInfo({ object_type: 'A' }));
    setLoadingPlans(false);
  };

  const handleCardClickWhatIncludes = plan => {
    dispatch(
      getWorkflowStart(plan?._links?.checkout?.href || plan?.linkworkflowstart),
    );
    dispatch(setCurrentPBI(plan)); //* ok --
    dispatch(hideHeadband());
    pushPaymentEvent(
      //* ok-----
      'selecciona tu plan - home',
      'home',
      'seleccion de plan',
      `contrata ${plan?.producttype}`,
    );
    pushBeginCheckoutEvent(plan); //* ok ---
    planSelectorMetrics(plan); //! ok ----
    // uno si otro no
  };

  const planSelectorMetrics = (plan, title) => {
    const countryCode = Utils.getAbbreviation(getRegion());
    const eventInfo = {
      event: 'plan_selector',
      content_section: `home ${nodesSelected?.text?.toLowerCase()}`,
      content_list: decodeString(title).toLowerCase(),
      content_id: plan?.product_id,
      content_name: plan?.family,
      content_availability: plan?.oneoffertype,
      content_brand: plan?.family,
      content_price: plan?.price?.amount,
      user_type: user?.userTypeLite,
      country: countryCode,
      user_id: user?.user_id,
      device: 'web',
    };

    return pushGTMEvent(eventInfo);
  };

  return {
    loadingTranslations,
    loadingAssets,
    getPlanSelectorKeys,
    getPlanSelectorTranslationKeyData,
    getPlanSelectorAssetKeys,
    getPlanSelectorAssetKeyData,
    getPlanSelectorOffers,
    loadingPlans,
    handleCardClickWhatIncludes,
    planSelectorMetrics,
  };
};
